import {
  Choice, Slider, SECTION_EMOJI, YES_NO_NSP,
  buildCommonStartSteps, buildTabacSteps, buildAlcoolSteps, buildMentalSteps, buildRedFlagsStep,
} from './BilanWidgets';

// Tranche 45-50 ans (version refactorée avec widgets partagés)
export function build4550Steps(config, answers, update) {
  return [
    ...buildCommonStartSteps(config, answers, update),
    ...buildTabacSteps(answers, update),
    ...buildAlcoolSteps(answers, update),
    // Activité physique
    { id: 'activite', emoji: SECTION_EMOJI.activite, title: 'Combien de minutes par semaine ?', subtitle: "Marche rapide, vélo, natation, jardinage... hors quotidien.",
      render: () => (
        <Slider testid="q-act" value={answers.activite_physique_min_sem} onChange={(v) => update({ activite_physique_min_sem: v })}
          min={0} max={420} step={15} unit=" min/sem"
          presets={[
            { value: 0, label: 'Aucune' },
            { value: 60, label: '~1h' },
            { value: 150, label: '~2h30' },
            { value: 300, label: '5h+' },
          ]}
          zones={[
            { color: 'bg-rose-200', label: 'Insuffisant' },
            { color: 'bg-amber-200', label: 'Moyen' },
            { color: 'bg-emerald-200', label: 'Bon' },
          ]} />
    )},
    ...buildMentalSteps(answers, update),
    // Vaccinations
    { id: 'vaccin_dtp', emoji: SECTION_EMOJI.vaccin, title: 'Vaccin DTP à jour ?', subtitle: 'Diphtérie — Tétanos — Poliomyélite',
      render: (a, u, advance) => <Choice testid="q-vac-dtp" value={answers.vaccin_dtp} onChange={(v) => { update({ vaccin_dtp: v }); advance(); }} options={YES_NO_NSP} />
    },
    { id: 'vaccin_grippe', emoji: SECTION_EMOJI.vaccin, title: 'Grippe cette année ?',
      render: (a, u, advance) => <Choice testid="q-vac-gr" value={answers.vaccin_grippe} onChange={(v) => { update({ vaccin_grippe: v }); advance(); }}
        options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    { id: 'vaccin_covid', emoji: SECTION_EMOJI.vaccin, title: 'COVID (moins de 1 an) ?',
      render: (a, u, advance) => <Choice testid="q-vac-cov" value={answers.vaccin_covid} onChange={(v) => { update({ vaccin_covid: v }); advance(); }}
        options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    // Dépistages conditionnels F
    ...(answers.sex === 'F' ? [
      { id: 'depistage_mammo', emoji: SECTION_EMOJI.depistage, title: 'Mammographie de dépistage (< 2 ans) ?',
        render: (a, u, advance) => <Choice testid="q-dep-m" value={answers.depistage_mammo} onChange={(v) => { update({ depistage_mammo: v }); advance(); }} options={YES_NO_NSP} /> },
      { id: 'depistage_fcu', emoji: SECTION_EMOJI.depistage, title: 'Frottis / test HPV (< 5 ans) ?',
        render: (a, u, advance) => <Choice testid="q-dep-f" value={answers.depistage_fcu} onChange={(v) => { update({ depistage_fcu: v }); advance(); }} options={YES_NO_NSP} /> },
    ] : []),
    { id: 'depistage_hemoccult', emoji: SECTION_EMOJI.depistage, title: 'Dépistage cancer colorectal (< 2 ans) ?', subtitle: 'Test "Hemoccult" envoyé par la poste',
      render: (a, u, advance) => <Choice testid="q-dep-h" value={answers.depistage_hemoccult} onChange={(v) => { update({ depistage_hemoccult: v }); advance(); }}
        options={[{value:'ok',label:'Fait'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} />
    },
    ...(answers.sex === 'H' ? [
      { id: 'depistage_psa', emoji: SECTION_EMOJI.depistage, title: 'Dosage PSA (prostate) évoqué avec un médecin ?',
        render: (a, u, advance) => <Choice testid="q-dep-p" value={answers.depistage_psa} onChange={(v) => { update({ depistage_psa: v }); advance(); }}
          options={[{value:'ok',label:'Oui'},{value:'nsp',label:'Pas sûr'},{value:'no',label:'Non'}]} /> },
    ] : []),
    ...buildRedFlagsStep(config, answers, update),
  ];
}
